<script>
import resources from './resources'

export default {
  name: 'meeting',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Assembléia - {{ meeting.meeting_date }}
        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.meetings.details', params: {id: meeting.id}}") Detalhes
      .body.m-b-10
        //-ul.meta
            li
              a(href='javascript:void(0);')
                i.zmdi.zmdi-account.col-blue
                | Posted By: John Smith
            li
              a(href='javascript:void(0);')
                i.zmdi.zmdi-label.col-amber
                | Technology
            li
              a(href='javascript:void(0);')
                i.zmdi.zmdi-comment-text.col-blue
                | Comments: 3
        h3.m-t-0
          strong {{ meeting.title }}
        p(v-html="meeting.content.slice(0, 300)")
        router-link.cursor-pointer.btn.btn-raised.btn-primary.btn-icon.btn-icon-mini.btn-round(
          :to="{name: 'dweller.meetings.details', params: {id: meeting.id, rtn: 'details'}}",
          style="background: #7159c1; float: rigth;"
        )
          i.zmdi.zmdi-eye(style="margin-top: 9px;")

</template>
<style scoped>
  .size-100 {
    width: 100%;
  }
  .modal-body {
      min-height: 300px;
      overflow-y: auto;
  }

  .cursor-pointer {
    cursor: pointer;
  }
  p {
    font-size: 12px;
    text-align: justify;
  }
  h3 {
    font-size: 12px;
    line-height: 15px;
    -webkit-transition: color .4s ease;
    transition: color .4s ease;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/meeting/index/components/item.vue